module.exports = __webpack_public_path__ + "img/av013.91b27502.png";